export enum ErrorCode {
  LAST_GROUP_ADMIN = 100,
  LAST_ORGANIZATION_OWNER = 101,
}
